import React from "react";
import LinkedTravelRowCard, { getLinkedTravelInfo } from "./linkedtravelrow";

interface IProps {
  appointments: server.dto.AppointmentForList[]
  icon: string
  title: string
  unlink: (appointmentId: number) => void
  canLinkUnlinkTravel: boolean
}

// TODO: See if these get updated and how
const LinkedTravelRows = (props: IProps) => {
  if (!props.appointments || props.appointments.length === 0) {
    return null;
  }

  return (<div className="margin-bottom">

    <div className="list-with-gaps card-layout">
      <div className="list-with-gaps-header">
        <div className="flex gap align-center" style={{ background: "none", paddingTop: 0, paddingLeft: 4 }}>
          <div>
            <i className={props.icon}></i>
          </div>
          <div className="">
            <h3>{props.title}</h3>
          </div>
        </div>
      </div>

      <div className="list-with-gaps-body">
        {props.appointments
          .map((app) => (
            <LinkedTravelRowCard
              key={getLinkedTravelInfo(app).id}
              appointment={app}
              unlink={props.unlink}
              canLinkUnlinkTravel={props.canLinkUnlinkTravel}
            />
          ))}
      </div>
    </div>
  </div>
  );
};

export default LinkedTravelRows;